import script from "./HearAboutUs.vue?vue&type=script&setup=true&lang=js"
export * from "./HearAboutUs.vue?vue&type=script&setup=true&lang=js"

import "./HearAboutUs.vue?vue&type=style&index=0&id=72b7e23c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b7e23c"]])

export default __exports__